import React from "react";
import InfoHuurders from "./infoHuurders";

const HuurdersComponent = (props) => {
  return <InfoHuurders />;
};

export default HuurdersComponent;
